// src/utils/authUtils.ts

import { useCallback } from 'react'
import { useRecoilState } from 'recoil'
import { authInitializedState, authState } from '../atoms/auth'
import { getUser } from '../services/apiService'

export const useAuthState = () => {
  const [auth, setAuth] = useRecoilState(authState)
  const [, setAuthInitialized] = useRecoilState(authInitializedState)

  const reloadUser = useCallback(async () => {
    try {
      const { data: res } = await getUser()
      if (res.statusCode === 200) {
        setAuth(res.data)
        return res.data
      }
    } catch {
      // A 401 response simply means the visitor is browsing without signing in.
    } finally {
      setAuthInitialized(true)
    }
    return null
  }, [setAuth, setAuthInitialized])

  const initUser = useCallback(async () => {
    setAuth({
      id: 0,
      account: '',
      username: '',
      email: null,
      profileImage: null,
      name: null,
      phone: null,
      birthDate: null,
      gender: null,
      address: null,
      isPremium: null,
      isAdmin: 0,
      serviceDeadline: null,
      createdAt: null
    })
    setAuthInitialized(true)
  }, [setAuth, setAuthInitialized])

  // ✅ 반환 추가
  return {
    auth,
    reloadUser,
    initUser
  }
}
